// src/pages/SubscriptionPlans.js
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { subscriptionPlans } from '../data/subscriptionPlans';

function SubscriptionPlans() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  return (
    <div>
      {/* ── Hero ──────────────────────────────────────────────────── */}
      <section style={{ padding: '64px 0 48px', textAlign: 'center' }}>
        <div className="fc-wrap">
          <span className="fc-eyebrow">Priser</span>
          <h1 style={{
            fontSize: 'clamp(32px, 5vw, 56px)',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            lineHeight: 1.05,
            color: 'var(--text-primary)',
            marginBottom: 16,
          }}>
            Simpelt. Transparent.{' '}
            <em style={{ fontStyle: 'normal', color: 'var(--primary-color)' }}>Fair.</em>
          </h1>
          <p style={{ fontSize: 18, color: 'var(--text-secondary)', maxWidth: 480, margin: '0 auto 12px', lineHeight: 1.6 }}>
            30 kr om måneden. 80% går direkte til de podcasts du lytter til.
          </p>
          <p style={{ fontSize: 14, color: 'var(--text-mute)' }}>
            Tilmeld dig via vores hjemmeside — og du undgår Apples 30% app store-gebyr.
          </p>
        </div>
      </section>

      {/* ── Plan cards ────────────────────────────────────────────── */}
      <section style={{ padding: '0 0 64px' }}>
        <div className="fc-wrap">
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 24,
            flexWrap: 'wrap',
          }}>
            {subscriptionPlans.map(plan => {
              const selected = selectedPlan === plan.id;
              return (
                <div
                  key={plan.id}
                  onClick={() => setSelectedPlan(plan.id)}
                  style={{
                    background: 'var(--bg-card)',
                    border: `2px solid ${selected ? 'var(--primary-color)' : 'var(--border-color)'}`,
                    borderRadius: 20,
                    padding: '32px 28px',
                    width: '100%',
                    maxWidth: 340,
                    cursor: 'pointer',
                    transition: 'border-color 0.15s, transform 0.15s',
                    transform: selected ? 'translateY(-4px)' : 'none',
                    boxShadow: selected ? '0 16px 40px rgba(255,107,53,0.15)' : 'none',
                  }}
                >
                  {/* Header */}
                  <div style={{ marginBottom: 24 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                      <h3 style={{ fontWeight: 700, fontSize: 18, color: 'var(--text-primary)' }}>{plan.name}</h3>
                      {selected && (
                        <span style={{
                          background: 'var(--primary-dim)',
                          border: '1px solid rgba(255,107,53,0.4)',
                          color: 'var(--primary-color)',
                          borderRadius: 100,
                          padding: '2px 10px',
                          fontSize: 11,
                          fontWeight: 700,
                        }}>Valgt</span>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                      <span style={{
                        fontFamily: "'JetBrains Mono', monospace",
                        fontSize: 36,
                        fontWeight: 800,
                        color: 'var(--text-primary)',
                      }}>{plan.price}</span>
                      <span style={{ fontSize: 16, color: 'var(--text-mute)' }}>{plan.currency}</span>
                      <span style={{ fontSize: 14, color: 'var(--text-mute)' }}>
                        / {plan.interval === 'month' ? 'md.' : 'år'}
                      </span>
                    </div>
                    <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 8, lineHeight: 1.5 }}>{plan.description}</p>
                  </div>

                  {/* Features */}
                  <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px' }}>
                    {plan.features.map((feature, i) => (
                      <li key={i} style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 10,
                        padding: '6px 0',
                        fontSize: 14,
                        color: 'var(--text-secondary)',
                        borderBottom: '1px solid var(--border-color)',
                      }}>
                        <span style={{ color: 'var(--primary-color)', marginTop: 1, flexShrink: 0 }}>✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <button
                    style={{
                      width: '100%',
                      padding: '12px 0',
                      borderRadius: 10,
                      border: `1px solid ${selected ? 'var(--primary-color)' : 'var(--border-strong)'}`,
                      background: selected ? 'var(--primary-color)' : 'transparent',
                      color: selected ? 'white' : 'var(--text-secondary)',
                      fontWeight: 700,
                      fontSize: 14,
                      cursor: 'pointer',
                      transition: 'all 0.15s',
                    }}
                  >
                    {selected ? 'Valgt' : 'Vælg'}
                  </button>
                </div>
              );
            })}
          </div>

          {/* CTA after selection */}
          {selectedPlan && (
            <div style={{ textAlign: 'center', marginTop: 36 }}>
              <Link
                to={`/checkout/${selectedPlan}`}
                className="fc-cta-primary"
                style={{ display: 'inline-flex' }}
              >
                Fortsæt til betaling →
              </Link>
            </div>
          )}
        </div>
      </section>

      {/* ── Why web ───────────────────────────────────────────────── */}
      <section style={{ padding: '48px 0 64px', background: 'var(--bg-card)', borderTop: '1px solid var(--border-color)' }}>
        <div className="fc-wrap" style={{ maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
          <span className="fc-eyebrow">Hvorfor tilmelde sig via hjemmesiden?</span>
          <h2 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 12 }}>
            Mere til skaberne
          </h2>
          <p style={{ fontSize: 16, color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: 16 }}>
            Når du tilmelder dig via vores hjemmeside frem for appen, undgår vi Apples 30% app store-gebyr. Det betyder at hele 80% af dit abonnement går til skaberne — i stedet for kun 56%.
          </p>
          <p style={{ fontSize: 14, color: 'var(--text-mute)', lineHeight: 1.7 }}>
            Du bruger den samme konto på både hjemmeside og app. Ingen forskel i adgang — kun forskel i hvem pengene havner hos.
          </p>
        </div>
      </section>
    </div>
  );
}

export default SubscriptionPlans;
